import * as yup from 'yup';

import {
  EN_PAGE_TOPIC_CHAR_LIMIT,
} from '@lessonPlanner/constants';

export default yup.object().shape({
  gradeLevel: yup.string().required('Please select a grade level'),
  topic: yup
    .string()
    .test(
      'len',
      'You have reached the character limit',
      (val: any) => !val || val.length <= EN_PAGE_TOPIC_CHAR_LIMIT,
    ),
});
